import { lighten } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

const SmallButton = props =>
  makeStyles(theme => {
    const { typography, palette } = theme;
    const { pxToRem } = typography;

    return {
      rootButton: {
        fontSize: pxToRem(12),
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: `${pxToRem(6)} ${pxToRem(22)}`,
        fontWeight: 'regular',
        height: pxToRem(29),
        marginLeft: `${pxToRem(10)}`,
        marginRight: `${pxToRem(10)}`,
        width: 'max-content',
        '&.MuiButton-root.Mui-disabled': {
          color: palette.common.black,
          backgroundColor: palette.common.disabled
        },
        '&.light': {
          background: palette.primary.main,
          color: palette.text.button,
          '&:hover': {
            background: lighten(palette.primary.main, 0.2)
          }
        },
        '&.white': {
          border: `1px solid ${palette.primary.main}`,
          boxShadow: props.boxShadow ? `1px 1px 2px 0px ${palette.common.grayColor}` : 'none',
          color: palette.text.primary,
          '&:hover': {
            background: lighten(palette.primary.main, 0.7)
          }
        }
      }
    };
  });
export default SmallButton;
